/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pre-op-sign-in.reducer';

export const PreOpSignInDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const preOpSignInEntity = useAppSelector(state => state.preOpSignIn.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="preOpSignInDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.preOpSignIn.detail.title">PreOpSignIn</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.preOpSignIn.id">Id</Translate>
            </span>
          </dt>
          <dd>{preOpSignInEntity.id}</dd>
          <dt>
            <span id="patientConfirmation">
              <Translate contentKey="tinyMedicRestApp.preOpSignIn.patientConfirmation">Patient Confirmation</Translate>
            </span>
          </dt>
          <dd>{preOpSignInEntity.patientConfirmation ? 'true' : 'false'}</dd>
          <dt>
            <span id="identity">
              <Translate contentKey="tinyMedicRestApp.preOpSignIn.identity">Identity</Translate>
            </span>
          </dt>
          <dd>{preOpSignInEntity.identity ? 'true' : 'false'}</dd>
          <dt>
            <span id="siteAndSide">
              <Translate contentKey="tinyMedicRestApp.preOpSignIn.siteAndSide">Site And Side</Translate>
            </span>
          </dt>
          <dd>{preOpSignInEntity.siteAndSide ? 'true' : 'false'}</dd>
          <dt>
            <span id="procedure">
              <Translate contentKey="tinyMedicRestApp.preOpSignIn.procedure">Procedure</Translate>
            </span>
          </dt>
          <dd>{preOpSignInEntity.procedure ? 'true' : 'false'}</dd>
          <dt>
            <span id="consent">
              <Translate contentKey="tinyMedicRestApp.preOpSignIn.consent">Consent</Translate>
            </span>
          </dt>
          <dd>{preOpSignInEntity.consent ? 'true' : 'false'}</dd>
          <dt>
            <span id="siteMarked">
              <Translate contentKey="tinyMedicRestApp.preOpSignIn.siteMarked">Site Marked</Translate>
            </span>
          </dt>
          <dd>{preOpSignInEntity.siteMarked ? 'true' : 'false'}</dd>
          <dt>
            <span id="anaesthesiaCheck">
              <Translate contentKey="tinyMedicRestApp.preOpSignIn.anaesthesiaCheck">Anaesthesia Check</Translate>
            </span>
          </dt>
          <dd>{preOpSignInEntity.anaesthesiaCheck ? 'true' : 'false'}</dd>
          <dt>
            <span id="knownAllergies">
              <Translate contentKey="tinyMedicRestApp.preOpSignIn.knownAllergies">Known Allergies</Translate>
            </span>
          </dt>
          <dd>{preOpSignInEntity.knownAllergies ? 'true' : 'false'}</dd>
          <dt>
            <span id="airwayRisk">
              <Translate contentKey="tinyMedicRestApp.preOpSignIn.airwayRisk">Airway Risk</Translate>
            </span>
          </dt>
          <dd>{preOpSignInEntity.airwayRisk ? 'true' : 'false'}</dd>
          <dt>
            <span id="bloodLoss">
              <Translate contentKey="tinyMedicRestApp.preOpSignIn.bloodLoss">Blood Loss</Translate>
            </span>
          </dt>
          <dd>{preOpSignInEntity.bloodLoss ? 'true' : 'false'}</dd>
          <dt>
            <span id="bloodReserved">
              <Translate contentKey="tinyMedicRestApp.preOpSignIn.bloodReserved">Blood Reserved</Translate>
            </span>
          </dt>
          <dd>{preOpSignInEntity.bloodReserved ? 'true' : 'false'}</dd>
          <dt>
            <span id="documentsReady">
              <Translate contentKey="tinyMedicRestApp.preOpSignIn.documentsReady">Documents Ready</Translate>
            </span>
          </dt>
          <dd>{preOpSignInEntity.documentsReady ? 'true' : 'false'}</dd>
          <dt>
            <span id="equipmentReady">
              <Translate contentKey="tinyMedicRestApp.preOpSignIn.equipmentReady">Equipment Ready</Translate>
            </span>
          </dt>
          <dd>{preOpSignInEntity.equipmentReady ? 'true' : 'false'}</dd>
          <dt>
            <span id="implantReady">
              <Translate contentKey="tinyMedicRestApp.preOpSignIn.implantReady">Implant Ready</Translate>
            </span>
          </dt>
          <dd>{preOpSignInEntity.implantReady ? 'true' : 'false'}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.preOpSignIn.active">Active</Translate>
            </span>
          </dt>
          <dd>{preOpSignInEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.preOpSignIn.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{preOpSignInEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.preOpSignIn.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{preOpSignInEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.preOpSignIn.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{preOpSignInEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.preOpSignIn.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{preOpSignInEntity.timestampentry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.preOpSignIn.surgery">Surgery</Translate>
          </dt>
          <dd>{preOpSignInEntity.surgery ? preOpSignInEntity.surgery.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.preOpSignIn.anaesthesiologist">Anaesthesiologist</Translate>
          </dt>
          <dd>{preOpSignInEntity.anaesthesiologist ? preOpSignInEntity.anaesthesiologist.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.preOpSignIn.nurse">Nurse</Translate>
          </dt>
          <dd>{preOpSignInEntity.nurse ? preOpSignInEntity.nurse.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pre-op-sign-in" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pre-op-sign-in/${preOpSignInEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PreOpSignInDetail;
